module.exports = __webpack_public_path__ + "res/img_landing_2.125e89f4beca1faec07382ee374a42a7.webp";